import { CLASSIC_THEME } from './themes/classic';
import { CIRCUIT_THEME } from './themes/circuit';
import { ALVA_THEME } from './themes/alva';
import { ATELIER_THEME } from './themes/atelier';
import { AUREA_THEME } from './themes/aurea';
import { ESSENCE_THEME } from './themes/essence';
import { GLOW_THEME } from './themes/glow';
import { HOMESTORE_THEME } from './themes/homestore';
import { LINEN_THEME } from './themes/linen';
import { LUMEN_THEME } from './themes/lumen';
import { MAISON_THEME } from './themes/maison';
import { NEON_THEME } from './themes/neon';
import { NOIR_THEME } from './themes/noir';
import { NORDIC_THEME } from './themes/nordic';
import { PIXEL_THEME } from './themes/pixel';
import { ARENA_THEME } from './themes/arena';
import { PODIUM_THEME } from './themes/podium';
import { TRAIL_THEME } from './themes/trail';
import { ROUTE_THEME } from './themes/route';
import { TURBO_THEME } from './themes/turbo';
import { PILOT_THEME } from './themes/pilot';
import { MARKET_THEME } from './themes/market';
import { BISTRO_THEME } from './themes/bistro';
import { HARVEST_THEME } from './themes/harvest';
import { MASCOT_THEME } from './themes/mascot';
import { SNOUT_THEME } from './themes/snout';
import { PAW_THEME } from './themes/paw';
import { AGENDA_THEME } from './themes/agenda';
import { FOUNDATION_THEME } from './themes/foundation';
import { CARE_THEME } from './themes/care';
import { RUNWAY_THEME } from './themes/runway';
import { SPARKLE_THEME } from './themes/sparkle';
/** Etiquetas de estilo da galeria (decisão do owner em 2026-10-17; joalheria, esporte e auto em 2026-10-20). */
export const THEME_STYLE_TAGS = [
    { value: 'fashion', label: 'Moda' },
    { value: 'home', label: 'Casa' },
    { value: 'beauty', label: 'Beleza' },
    { value: 'jewelry', label: 'Joalheria' },
    // Valor mantido; o nome exibido virou "Tecnologia" (2026-10-20), mais amplo que eletrônicos.
    { value: 'electronics', label: 'Tecnologia' },
    { value: 'sports', label: 'Esporte' },
    // Veículos, peças e acessórios.
    { value: 'auto', label: 'Auto' },
    { value: 'food', label: 'Alimentação' },
    { value: 'pet', label: 'Pet' },
    { value: 'services', label: 'Serviços' },
];
/** Tema usado por quem não escolheu nenhum. */
export const DEFAULT_THEME_SLUG = CLASSIC_THEME.slug;
/**
 * Todos os temas. Tema novo (preset) entra só aqui: os componentes são uma biblioteca
 * única. O protocolo completo de criação está em `docs/store-theme-recipe.md`.
 */
export const THEME_MANIFESTS = {
    [CLASSIC_THEME.slug]: CLASSIC_THEME,
    [MAISON_THEME.slug]: MAISON_THEME,
    [LINEN_THEME.slug]: LINEN_THEME,
    [RUNWAY_THEME.slug]: RUNWAY_THEME,
    [NOIR_THEME.slug]: NOIR_THEME,
    [ATELIER_THEME.slug]: ATELIER_THEME,
    [NORDIC_THEME.slug]: NORDIC_THEME,
    [HOMESTORE_THEME.slug]: HOMESTORE_THEME,
    [ALVA_THEME.slug]: ALVA_THEME,
    [ESSENCE_THEME.slug]: ESSENCE_THEME,
    [GLOW_THEME.slug]: GLOW_THEME,
    [LUMEN_THEME.slug]: LUMEN_THEME,
    [AUREA_THEME.slug]: AUREA_THEME,
    [SPARKLE_THEME.slug]: SPARKLE_THEME,
    [CIRCUIT_THEME.slug]: CIRCUIT_THEME,
    [NEON_THEME.slug]: NEON_THEME,
    [PIXEL_THEME.slug]: PIXEL_THEME,
    [ARENA_THEME.slug]: ARENA_THEME,
    [PODIUM_THEME.slug]: PODIUM_THEME,
    [TRAIL_THEME.slug]: TRAIL_THEME,
    [ROUTE_THEME.slug]: ROUTE_THEME,
    [TURBO_THEME.slug]: TURBO_THEME,
    [PILOT_THEME.slug]: PILOT_THEME,
    [MARKET_THEME.slug]: MARKET_THEME,
    [BISTRO_THEME.slug]: BISTRO_THEME,
    [HARVEST_THEME.slug]: HARVEST_THEME,
    [MASCOT_THEME.slug]: MASCOT_THEME,
    [SNOUT_THEME.slug]: SNOUT_THEME,
    [PAW_THEME.slug]: PAW_THEME,
    [AGENDA_THEME.slug]: AGENDA_THEME,
    [FOUNDATION_THEME.slug]: FOUNDATION_THEME,
    [CARE_THEME.slug]: CARE_THEME,
};
export function getThemeManifest(slug) {
    return (slug && THEME_MANIFESTS[slug]) || null;
}
//# sourceMappingURL=registry.js.map